import { v4 as uuidv4 } from 'uuid'
import { useEmberMessagesStore } from '../components/Ember/ember-messages.store'

const EMBER_AGENTS = ['chat', 'checklist', 'document', 'report'] as const
export type EmberThreadForAgent = (typeof EMBER_AGENTS)[number]

export const useEmberThread = (agent: EmberThreadForAgent = 'chat'): string => {
  const key = `ember_${agent}_threadId`

  // Try to fetch threadId from session storage
  const threadId = sessionStorage.getItem(key)
  if (threadId) {
    useEmberMessagesStore.getState().initThread(threadId)
    return threadId
  }

  // If nothing found, generate new UUID
  const newThreadId = `thr_${uuidv4()}`
  sessionStorage.setItem(key, newThreadId)
  useEmberMessagesStore.getState().initThread(newThreadId)
  return newThreadId
}

export const clearEmberThreadsFromStorage = () => {
  EMBER_AGENTS.forEach(agent => {
    const key = `ember_${agent}_threadId`
    sessionStorage.removeItem(key)
  })
}

export const resetEmberThread = (agent: EmberThreadForAgent = 'chat'): string => {
  const key = `ember_${agent}_threadId`
  sessionStorage.removeItem(key)

  // Generate new UUID
  const newThreadId = `thr_${uuidv4()}`
  sessionStorage.setItem(key, newThreadId)
  return newThreadId
}
